module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_morning-mix_wp_2016_02_05_wife-crashes-her-own-funeral-horrifying-her-husband-who-had-paid-have-her-killed__plot.6a688a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_02_05_wife-crashes-her-own-funeral-horrifying-her-husband-who-had-paid-have-her-killed__plot.png
// module id = 429
// module chunks = 0